module.exports = __webpack_public_path__ + "static/media/Jeddah.0fe5a530.jpg";